export function isAnalyticsAllowed() {

  const consent = localStorage.getItem("cookieConsent");

  if (!consent) return false;

  try {

    const settings = JSON.parse(consent);

    return settings.analytics === true;

  } catch {

    return false;

  }

}